<template>
  <div
    v-if="filters_templates.length"
    class="pinned-filters-templates"
    data-qa="pinned-filters-templates">
    <sDivider class="mx-4"/>
    <template v-if="small">
      <div
        v-for="(template) in filters_templates"
        :key="template.id"
        class="pinned-filters-item-small"
        :class="{'active': template.id === active_template}"
        :data-qa="'pinned-filters-template-' + template.id"
        @click="filterByTepmlate(template)">
        <sTooltip
          :border="false"
          :content="template.filterName"
          placement="right"
          type="dark">
          <sIcon
            line-height="34px"
            size="15"
            type="filter"/>
        </sTooltip>
      </div>
    </template>
    <template v-else>
      <div
        class="pinned-filters-header"
        data-qa="pinned-filters-templates-title">
        {{ $t('Common.Filters.FixedFilters') }}
      </div>
      <div
        v-for="(template) in filters_templates"
        :key="template.id"
        class="pinned-filters-item"
        :class="{'active': template.id === active_template}"
        :data-qa="'pinned-filters-template-' + template.id"
        @click="filterByTepmlate(template)">
        <span class="pinned-filters-item-label">{{ template.filterName }}</span>
        <FiltersTemplateDialog
          class-name="pinned-filters-item-btn"
          :item="template"
          only_edit>
          <template #item="{ item, disabled }">
            <slot
              :disabled="disabled"
              name="filter_template"
              :template="item"/>
          </template>
        </FiltersTemplateDialog>
      </div>
    </template>
  </div>
</template>

<script>
import FiltersTemplateDialog from 'components/common/dialogs/FiltersTemplateDialog.vue'

import { filtersTemplatesMixin, storageMixin } from 'mixins'

export default {
  name: 'pinnedFiltersTemplates',
  mixins: [ storageMixin, filtersTemplatesMixin],
  data() {
    return {
      active_template: null,
    }
  },
  mounted() {
    this.$root.$on('updateFiltersTepmlate', this.updateActive)
  },
  beforeDestroy() {
    this.$root.$off('updateFiltersTepmlate', this.updateActive)
  },
  computed: {
    filters() {
      let filters_templates = this.$store.getters.getFilters || {}
      return filters_templates[this.filters_type] || []
    },
    filters_templates() {
      let filters_templates = this.$store.getters.getFiltersTemplatesByType || {}
      return ( filters_templates[this.filters_type] || [] ).filter(el => el.isPinned)
    },
  },
  methods: {
    filterByTepmlate(template) {
      this.active_template = template.id
      this.$emit('updatePinnedFilters', JSON.parse(template.filterJson))
      this.$root.$emit('updateFilters', {
        template
      })
    },
    updateActive(id) {
      this.$nextTick(() => {
        this.active_template = id
      })
    },
  },
  props: {
    small: {
      type: Boolean
    }
  },
  components: {
    FiltersTemplateDialog
  }
}
</script>

<style scoped lang="scss">
.pinned-filters-header {
  height: unset;
  align-items: center;
  display: flex;
  color: rgba(var(--black-color-rgba), 0.6);
  font-weight: 500 !important;
  font-size: 11px !important;
  line-height: 14px !important;
  letter-spacing: 0.02em !important;
  padding: 12px 24px !important;
}
.pinned-filters-item-small {
  justify-content: center;
  width: 34px;
  min-height: 34px;
  height: 34px;
  border-radius: 32px;
  margin: 0 auto;
  margin-top: 5px;
  cursor: pointer;
  &.active {
    background-color: var(--v-secondary__green_chosen-base);
  }
}

.pinned-filters-item {
  min-height: 40px;
  padding: 0 13px 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.25s ease;
  cursor: pointer;
  &.active {
    background-color: var(--v-secondary__green_chosen-base);
  }
  &::v-deep .pinned-filters-item-btn {
    opacity: 0;
    width: 18px;
    transition: all 0.3s ease;
  }
  &:hover,
  &:focus {
    .pinned-filters-item-label {
      width: calc(100% - 40px);
    }
    &::v-deep .pinned-filters-item-btn {
      opacity: 1;
      width: auto;
    }
  }
}
.pinned-filters-item-label {
  font-size: 0.8125rem;
  font-weight: 500;
  line-height: 1rem;
  text-align: start;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  transition: all 0.25s ease;
  width: calc(100% - 18px);
}
</style>
